import React from "react";
import { useNavigate } from "react-router-dom";

const RADIUS = 54;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

const DonutRing = ({ total, completed }) => {
  const pct = total > 0 ? Math.min(completed / total, 1) : 0;
  const filled = pct * CIRCUMFERENCE;
  const gap = CIRCUMFERENCE - filled;

  return (
    <svg
      className="ssc-donut-svg"
      viewBox="0 0 140 140"
      width="140"
      height="140"
    >
      <circle
        cx="70"
        cy="70"
        r={RADIUS}
        fill="none"
        stroke="var(--ssc-track-color)"
        strokeWidth="13"
      />
      <circle
        cx="70"
        cy="70"
        r={RADIUS}
        fill="none"
        stroke="url(#sscGrad)"
        strokeWidth="13"
        strokeLinecap="round"
        strokeDasharray={`${filled} ${gap}`}
        strokeDashoffset={CIRCUMFERENCE * 0.25}
        style={{ transition: "stroke-dasharray 0.6s ease" }}
      />
      <defs>
        <linearGradient id="sscGrad" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#FAEE70" />
          <stop offset="100%" stopColor="#FCF4A3" />
        </linearGradient>
      </defs>
      <text
        x="70"
        y="64"
        textAnchor="middle"
        className="ssc-donut-label"
        fill="var(--dashboard-text-muted, #637381)"
        fontSize="16"
        fontWeight="600"
      >
        Total
      </text>
      <text
        x="70"
        y="88"
        textAnchor="middle"
        className="ssc-donut-value"
        fill="var(--dashboard-heading-color, #212b36)"
        fontSize="28"
        fontWeight="800"
      >
        {total}
      </text>
    </svg>
  );
};

const SideStatCards = ({ stats = [] }) => {
  const navigate = useNavigate();

  const handleStatClick = (index) => {
    if (index === 0) navigate("/active-recall");
    if (index === 1) navigate("/adaptive-learning");
  };

  return (
    <div className="side-stat-grid">
      {stats.map(({ title, total, completed }, index) => (
        <div
          className="side-stat-grid-item ssc-card"
          key={index}
          onClick={() => handleStatClick(index)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === "Enter" && handleStatClick(index)}
        >
          <p className="ssc-title">{title}</p>
          <div className="ssc-donut-wrap">
            <DonutRing total={total ?? 0} completed={completed ?? 0} />
          </div>
          <div className="ssc-footer">
            <span
              className="ssc-dot"
              style={{
                background: "linear-gradient(135deg, #FAEE70, #FCF4A3)",
                boxShadow: "0 2px 4px rgba(250, 238, 112, 0.3)",
              }}
            />
            <span className="ssc-completed-count" style={{ color: "#FCA43B" }}>
              {completed ?? 0}
            </span>
            <span className="ssc-completed-label">Completed</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SideStatCards;
